var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/text/common/src/heading-props.ts
var defaultHeadingProps = {
  typography: "heading01",
  color: "primary",
  display: "block",
  bold: false,
  italic: false,
  underline: false
};

// components/text/common/src/heading-style-sheet.ts
import { StyleSheet } from "@gs-ux-uitoolkit-common/style";
import { getOverflowStyles } from "@gs-ux-uitoolkit-common/shared";
import {
  createComponentClassDefinitions
} from "@gs-ux-uitoolkit-common/theme";

// components/text/common/src/typography-common-util.ts
import {
  colors,
  typographyFontFamilyVariants,
  typographyFonts
} from "@gs-ux-uitoolkit-common/design-system";
function getTextColor(props) {
  const { theme, color } = props;
  const typographyColor = theme.text[color];
  if (typographyColor != null) {
    return typographyColor;
  } else {
    return colors[color];
  }
}
function getBrowserResetStyles() {
  return {
    marginTop: "0px",
    // reset browser margins
    marginBottom: "0px"
    // reset browser margins
  };
}
function getFontStyles(args) {
  const { typography, bold, italic, theme } = args;
  const font = typographyFonts[typography];
  let fontStyle = "regular";
  if (bold && italic) {
    fontStyle = "boldItalic";
  } else if (bold) {
    fontStyle = "bold";
  } else if (italic) {
    fontStyle = "italic";
  }
  return __spreadValues(__spreadValues({}, theme.typography[typography]), typographyFontFamilyVariants[font][fontStyle]);
}

// components/text/common/src/heading-style-sheet.ts
var headingStyleSheet = new StyleSheet("heading", (props) => {
  var _a;
  return createComponentClassDefinitions(
    props,
    createDefaultStyledClasses,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.heading
  );
});
function createDefaultStyledClasses({
  theme,
  typography = defaultHeadingProps.typography,
  color,
  fontFamily,
  fontSize,
  fontWeight,
  lineHeight,
  display = defaultHeadingProps.display,
  bold,
  italic,
  underline,
  disabled
}) {
  const fontStyles = getFontStyles({
    theme,
    typography,
    bold,
    italic
  });
  return {
    root: __spreadValues(__spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, getBrowserResetStyles()), {
      display
    }), getOverflowStyles("wrap")), fontStyles), {
      textDecoration: underline ? "underline" : void 0,
      color: color ? getTextColor({ theme, color }) : "inherit",
      opacity: disabled ? theme.state.disabledOpacity : 1,
      fontWeight: bold ? "bold" : fontWeight || fontStyles.fontWeight,
      fontStyle: italic ? "italic" : "inherit"
    }), fontFamily && { fontFamily }), fontSize && { fontSize }), lineHeight && { lineHeight })
  };
}

// components/text/common/src/headings-style-sheet.ts
import { StyleSheet as StyleSheet2 } from "@gs-ux-uitoolkit-common/style";
var headingsStyleSheet = new StyleSheet2("headings", {
  h1: { margin: "8px 0px 16px" },
  h2: { margin: "20px 0px 12px" },
  h3: { margin: "20px 0px 12px" },
  h4: { margin: "20px 0px 12px" },
  h5: { margin: "20px 0px 8px" },
  h6: { margin: "20px 0px 4px" },
  h7: { margin: "20px 0px 4px" }
});

// components/text/common/src/heading-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var globalClassName = "gs-heading";
var getHeadingRootClassNames = (props) => {
  const { cssClasses, overrideClasses, className } = props;
  return cx(cssClasses.root, className, overrideClasses && overrideClasses.root, globalClassName);
};

// components/text/common/src/link-util.ts
import { cx as cx2 } from "@gs-ux-uitoolkit-common/style";
var globalClassName2 = "gs-link";
var getLinkRootClassNames = (props) => {
  const { cssClasses, className } = props;
  return cx2(cssClasses.root, cssClasses.anchor, className, globalClassName2);
};

// components/text/common/src/text-props.ts
var defaultTextProps = {
  typography: "body02",
  color: "primary",
  display: "inline-block",
  bold: false,
  italic: false,
  underline: false
};

// components/text/common/src/text-style-sheet.ts
import { StyleSheet as StyleSheet3 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions2 } from "@gs-ux-uitoolkit-common/theme";
import { getOverflowStyles as getOverflowStyles2 } from "@gs-ux-uitoolkit-common/shared";
var textStyleSheet = new StyleSheet3("text", (props) => {
  var _a;
  return createComponentClassDefinitions2(
    props,
    createDefaultStyledClasses2,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.text
  );
});
function createDefaultStyledClasses2({
  theme,
  typography = defaultTextProps.typography,
  color,
  fontFamily,
  fontSize,
  fontWeight,
  lineHeight,
  display = defaultTextProps.display,
  bold,
  italic,
  underline,
  disabled
}) {
  const fontStyles = getFontStyles({ theme, typography, bold, italic });
  return {
    root: __spreadValues(__spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, getBrowserResetStyles()), {
      display
    }), getOverflowStyles2("wrap")), fontStyles), {
      textDecoration: underline ? "underline" : void 0,
      color: color ? getTextColor({ theme, color }) : "inherit",
      fontWeight: bold ? "bold" : fontWeight || fontStyles.fontWeight,
      fontStyle: italic ? "italic" : "inherit",
      opacity: disabled ? theme.state.disabledOpacity : 1
    }), fontFamily && { fontFamily }), fontSize && { fontSize }), lineHeight && { lineHeight })
  };
}

// components/text/common/src/p-style-sheet.ts
import { StyleSheet as StyleSheet4 } from "@gs-ux-uitoolkit-common/style";
var pStyleSheet = new StyleSheet4("p", {
  p: {
    display: "block",
    margin: "6px 0px 12px"
  }
});

// components/text/common/src/text-util.ts
import { cx as cx3 } from "@gs-ux-uitoolkit-common/style";
var globalClassName3 = "gs-text";
var getTextRootClassNames = (props) => {
  const { cssClasses, overrideClasses, className } = props;
  return cx3(cssClasses.root, className, overrideClasses && overrideClasses.root, globalClassName3);
};

// components/text/common/src/typography-common-props.ts
var typographyColors = [
  "primary",
  "secondary",
  "tertiary",
  "link",
  "destructive",
  "reversed"
];

// components/text/common/src/link-props.ts
var defaultLinkProps = {
  href: "#",
  emphasis: "bold"
};

// components/text/common/src/link-style-sheet.ts
import {
  StyleSheet as StyleSheet5
} from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions3 } from "@gs-ux-uitoolkit-common/theme";
function getLinkSizeVariants(theme) {
  return {
    sm: {
      iconInnerSidePadding: "2px",
      iconSize: "14px",
      typographyVariant: theme.typography.body03
    },
    md: {
      iconInnerSidePadding: "4px",
      iconSize: "16px",
      typographyVariant: theme.typography.body02
    },
    lg: {
      iconInnerSidePadding: "4px",
      iconSize: "18px",
      typographyVariant: theme.typography.body01
    }
  };
}
function applyIconPosition(props) {
  const { size = "md", theme } = props;
  return {
    "> [data-gs-uitk-component='icon']:first-child:not(:only-child)": {
      // leading icon
      paddingRight: getLinkSizeVariants(theme)[size].iconInnerSidePadding,
      fontSize: getLinkSizeVariants(theme)[size].iconSize,
      verticalAlign: "sub"
    },
    "> [data-gs-uitk-component='icon']:last-child:not(:only-child)": {
      // trailing icon
      paddingLeft: getLinkSizeVariants(theme)[size].iconInnerSidePadding,
      fontSize: getLinkSizeVariants(theme)[size].iconSize,
      verticalAlign: "sub"
    }
  };
}
var linkStyleSheet = new StyleSheet5("link", (props) => {
  var _a;
  return createComponentClassDefinitions3(
    props,
    createDefaultStyledClasses3,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.link
  );
});
function createDefaultStyledClasses3({
  theme,
  emphasis,
  size
}) {
  const textDecoration = emphasis === "bold" ? "underline" : "none";
  const sizeVariant = size ? getLinkSizeVariants(theme)[size].typographyVariant : {};
  return {
    root: applyIconPosition({ size, theme }),
    anchor: __spreadProps(__spreadValues({}, sizeVariant), {
      textDecoration,
      borderRadius: "1px",
      "&:focus": {
        color: `${theme.colorScheme.primary}`,
        outline: "none",
        boxShadow: `0 0 0 1px ${theme.colorScheme.primary}, 0 0 0 1px ${theme.colorScheme.primary}`
      },
      "&:link": {
        color: `${theme.colorScheme.primary}`
      },
      "&:hover": {
        color: `${theme.increaseContrast(theme.colorScheme.primary, 1)}`
      },
      "&:active": {
        color: `${theme.increaseContrast(theme.colorScheme.primary, 1)}`
      },
      "&:visited": {
        color: `${theme.increaseContrast(theme.color.purple.bold, 1)}`
      }
    })
  };
}

// components/text/common/src/index.ts
import { textTypographies, headingTypographies } from "@gs-ux-uitoolkit-common/design-system";
export {
  applyIconPosition,
  defaultHeadingProps,
  defaultLinkProps,
  defaultTextProps,
  getHeadingRootClassNames,
  getLinkRootClassNames,
  getLinkSizeVariants,
  getTextRootClassNames,
  headingStyleSheet,
  headingTypographies,
  headingsStyleSheet,
  linkStyleSheet,
  pStyleSheet,
  textStyleSheet,
  textTypographies,
  typographyColors
};
//# sourceMappingURL=index.mjs.map
